import TwilioBreakoutRoom from './TwilioBreakoutRoom';

export default TwilioBreakoutRoom;
